import Button from './Button';
import PopupContainer from './PopupContainer';
import PopupOverlay from './PopupOverlay';
import { Offer, YSH_GTM_EVENTS } from '../types/types';
import { mapOfferToAnalyticsObject, pushToAnalytics } from '../utils/analytics';
import '../scss/email-confirmation-modal.scss';

interface Props {
  isModalActive: boolean;
  setIsModalActive: (value: boolean) => void;
  email: string;
  offer: Offer;
}

const EmailConfirmationModal = ({ isModalActive, setIsModalActive, email, offer }: Props) => {
  const handleEmailConfirmation = () => {
    pushToAnalytics({
      eventName: YSH_GTM_EVENTS.SET_REMINDER,
      data: {
        coupon_details: [mapOfferToAnalyticsObject(offer, 'Uskoro dostupno')],
        reminder_type: 'email'
      }
    });

    setIsModalActive(false);
  };

  return (
    <PopupOverlay className="email-preview-popup" onClick={() => setIsModalActive}>
      <PopupContainer
        isActive={isModalActive}
        setIsActive={setIsModalActive}
        handlePopupClosure={() => setIsModalActive(false)}
        baseClassName="email-confirmation-modal"
      >
        <div className="email-confirmation-modal-content">
          <span className="font-yettel-bold">Obavesti me kada kupon bude aktivan</span>
          <div className="input-and-button">
            <label htmlFor="email-input-readonly'">Email:</label>
            <input readOnly id="email-input-readonly" className="yettel-input color-inactive-color" value={email} />
            <Button className="mt-3" onClick={() => handleEmailConfirmation()}>
              OK
            </Button>
          </div>
        </div>
      </PopupContainer>
    </PopupOverlay>
  );
};

export default EmailConfirmationModal;
